<script setup lang="ts">
import {onMounted} from 'vue';
import {RouterView} from 'vue-router';
import AppShell from '@/views/shell/AppShell.vue';
import {type NavItem} from '@/views/shell/navItems.js';
import {reload} from '@/base/loadingState.js';

const ITEMS: NavItem[] = [];

onMounted(async () => {
    await reload();
});
</script>

<template>
    <AppShell landing="Dashboard" :items="ITEMS">
        <RouterView/>
    </AppShell>
</template>
